import "../QuoteForm.css";

function GeneralInfoSection({ publisherInfo, customerInfo, handleCustomerInfoChange }) {
    const quoteDate = new Date()
        .toLocaleDateString("ko-KR", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        })
        .replace(/\. /g, ".")
        .slice(0, -1);

    return (
        <div className="general-info-grid">
            <div className="publisher-info">
                <h2>출판사 정보</h2>
                <div className="info-item">
                    <label>회사명:</label>
                    <input
                        type="text"
                        name="companyName"
                        value={publisherInfo.companyName}
                        disabled={true}
                    />
                </div>
                <div className="info-item">
                    <label>주소:</label>
                    <input
                        type="text"
                        name="address"
                        value={publisherInfo.address}
                        disabled={true}
                    />
                </div>
                <div className="info-item">
                    <label>전화번호:</label>
                    <input
                        type="text"
                        name="phone"
                        value={publisherInfo.phone}
                        disabled={true}
                    />
                </div>
                <div className="info-item">
                    <label>전자우편:</label>
                    <input
                        type="email"
                        name="email"
                        value={publisherInfo.email}
                        disabled={true}
                    />
                </div>
            </div>
            <div className="customer-info">
                <h2>고객 정보</h2>
                <div className="info-item">
                    <label>
                        이메일: <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                        type="email"
                        name="email"
                        value={customerInfo.email}
                        onChange={handleCustomerInfoChange}
                        placeholder="이메일 주소를 입력해 주세요"
                        // disabled={true}
                    />
                </div>
                <div className="info-item">
                    <label>성명:</label>
                    <input
                        type="text"
                        name="name"
                        value={customerInfo.name}
                        onChange={handleCustomerInfoChange}
                        placeholder="이름을 입력해 주세요"
                    />
                </div>
                <div className="info-item">
                    <label>연락처:</label>
                    <input
                        type="text"
                        name="contact"
                        value={customerInfo.contact}
                        onChange={handleCustomerInfoChange}
                        placeholder="연락처를 입력해 주세요"
                    />
                </div>
                <div className="info-item">
                    <label>견적일:</label>
                    <span>{quoteDate}</span>
                </div>
            </div>
        </div>
    );
}

export default GeneralInfoSection;